var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHaxeFlixelDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    fill: "none",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#242938",
    rx: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0C3",
    d: "M56.8047 55.9771H199.633V199.839H56.8047V55.9771Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC3",
    d: "M33 32H80.6094L128.219 55.977L56.8047 127.908L33 79.9541V32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F36",
    d: "M128.219 55.977L175.828 32H223.437V79.9541L199.633 127.908L128.219 55.977Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#33F",
    d: "M56.8047 127.908L128.219 199.839L80.6094 223.816H33V175.862L56.8047 127.908Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CF",
    d: "M199.633 127.908L223.437 175.862V223.816H175.828L128.219 199.839L199.633 127.908Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaxeFlixelDark);
export default __webpack_public_path__ + "static/media/HaxeFlixel-Dark.5c7abd132aa2205fc3e5e53a97fe2340.svg";
export { ForwardRef as ReactComponent };